/* Mobile sticky buy bar (product pages, phones only).
   The button always goes through the main product form's own Add to cart
   button, so the theme and the Mini Custom Fields app still check every
   required option before anything is added to the cart.
   Impulse 10: the product area is re-rendered when a variant changes, so all
   elements are looked up fresh every time instead of being stored once. */
(function () {
  'use strict';

  var bar = document.getElementById('mobile-sticky-buy-bar');
  if (!bar) return;

  var SECTION_SELECTOR = '.product-section[data-section-type="product"]:not(.is-modal)';
  var stickyBtn = bar.querySelector('[data-sticky-atc]');
  var priceEl = bar.querySelector('[data-sticky-price]');
  var compareEl = bar.querySelector('[data-sticky-compare]');
  var mq = window.matchMedia('(max-width: 768px)');
  var nativeInView = false;
  var observedBtn = null;
  var io = null;

  function els() {
    var section = document.querySelector(SECTION_SELECTOR);
    var form = section && section.querySelector('form[action*="/cart/add"]');
    /* Zain buying boxes (shelf cover and gate templates) use their own Add to cart */
    var zbox = section && section.querySelector('.scb, .gbb');
    if (zbox) {
      return {
        section: section,
        form: zbox,
        btn: zbox.querySelector('.scb__atc, .gbb__atc'),
        price: zbox.querySelector('[data-scb="total"], [data-gbb="total"]'),
        compare: null
      };
    }
    return {
      section: section,
      form: form,
      btn: form && form.querySelector('button[name="add"]'),
      price: section && section.querySelector('[data-product-price]'),
      compare: section && section.querySelector('[data-compare-price]')
    };
  }

  if (!els().btn) {
    bar.parentNode.removeChild(bar);
    return;
  }

  function isMobile() {
    return mq.matches;
  }

  function updateVisibility() {
    var show = isMobile() && !nativeInView;
    bar.classList.toggle('is-hidden', !show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.body.classList.toggle('sticky-buy-bar-visible', show);
    document.body.classList.toggle('has-sticky-buy-bar', isMobile());
    liftPopupTeasers(show);
  }

  /* Move the Mailchimp "GET $20 OFF" tab (bottom left) above the bar while it is showing.
     The tab lives inside the app's shadow DOM, so it is adjusted here and not in CSS. */
  function liftPopupTeasers(on) {
    var hosts = document.querySelectorAll('[id^="mcforms-"]');
    for (var i = 0; i < hosts.length; i++) {
      var root = hosts[i].shadowRoot;
      if (!root) continue;
      var divs = root.querySelectorAll('div');
      for (var j = 0; j < divs.length; j++) {
        var el = divs[j];
        if (!el.hasAttribute('data-sbb-lift')) {
          var cs = window.getComputedStyle(el);
          if (cs.position !== 'fixed' || cs.bottom !== '0px') continue;
          el.setAttribute('data-sbb-lift', '');
        }
        if (on) {
          el.style.setProperty('bottom', (bar.offsetHeight + 8) + 'px', 'important');
        } else {
          el.style.removeProperty('bottom');
        }
      }
    }
  }

  /* Copy price, compare price and button state from the main product form,
     so the bar always matches the selected variant and store currency. */
  function syncFromProduct() {
    var e = els();
    if (e.price && e.price.textContent.trim()) {
      priceEl.textContent = e.price.textContent.trim();
    }
    if (compareEl) {
      var compareText = e.compare ? e.compare.textContent.trim() : '';
      var compareShown = e.compare && compareText && e.compare.offsetParent !== null;
      compareEl.textContent = compareText;
      compareEl.hidden = !compareShown;
    }
    if (e.btn) {
      var label = e.btn.querySelector('[data-add-to-cart-text]') || e.btn;
      stickyBtn.textContent = label.textContent.trim() || 'Add to cart';
      stickyBtn.disabled = e.btn.disabled;
    }
    watchNativeButton(e.btn);
  }

  /* Hide the bar while the main Add to cart button is on screen */
  function watchNativeButton(btn) {
    if (!('IntersectionObserver' in window) || !btn || btn === observedBtn) return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        nativeInView = entries[entries.length - 1].isIntersecting;
        updateVisibility();
      });
    }
    io.disconnect();
    io.observe(btn);
    observedBtn = btn;
  }

  /* Re-sync whenever the product area changes (variant change, section refresh) */
  var syncTimer = null;
  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncFromProduct, 80);
  }
  if ('MutationObserver' in window) {
    var target = els().section || document.body;
    new MutationObserver(scheduleSync).observe(target, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'class', 'style', 'hidden']
    });
  }
  document.addEventListener('variant:change', scheduleSync);

  function errorShown() {
    var modal = document.querySelector('.minimate-error-message-modal');
    return !!(modal && modal.offsetParent !== null);
  }

  function scrollToEl(target) {
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  stickyBtn.addEventListener('click', function () {
    if (stickyBtn.disabled) return;
    var e = els();
    if (!e.btn) return;

    /* A required field in the product form is empty: take the customer to it first */
    var invalid = e.form.querySelector('input:invalid, select:invalid, textarea:invalid');
    if (invalid) {
      scrollToEl(invalid);
      window.setTimeout(function () {
        try { invalid.focus({ preventScroll: true }); } catch (err) {}
        var fresh = els().btn;
        if (fresh) fresh.click();
      }, 450);
      return;
    }

    /* Everything looks complete: use the normal Add to cart button,
       so all theme and app checks still run */
    e.btn.click();

    /* If the custom fields app still blocks the order, show the form */
    window.setTimeout(function () {
      if (errorShown()) scrollToEl(els().form);
    }, 400);
  });

  /* The popup app loads a few seconds after the page, so check again for a while */
  var teaserChecks = 0;
  var teaserTimer = window.setInterval(function () {
    liftPopupTeasers(!bar.classList.contains('is-hidden'));
    if (++teaserChecks >= 20) window.clearInterval(teaserTimer);
  }, 1500);

  if (mq.addEventListener) {
    mq.addEventListener('change', updateVisibility);
  } else if (mq.addListener) {
    mq.addListener(updateVisibility);
  }

  syncFromProduct();
  updateVisibility();
})();
